import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="girlsvolleyball.id" />
      <TextField source="girlsvolleyball.playerGameCount" />
      <TextField source="girlsvolleyball.kills" />
      <TextField source="girlsvolleyball.aces" />
      <TextField source="girlsvolleyball.digs" />
      <TextField source="girlsvolleyball.blocks" />
      <TextField source="girlsvolleyball.assists" />
      <TextField source="girlsvolleyball.killsPerGame" />
      <TextField source="girlsvolleyball.acesPerGame" />
      <TextField source="girlsvolleyball.digsPerGame" />
      <TextField source="girlsvolleyball.blocksPerGame" />
      <TextField source="girlsvolleyball.assistsPerGame" />
    </SimpleShowLayout>
  );
};

export default Tab;
